<template>
  <div id="App">
    <keep-alive include="storeApply">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  created() {
    window.onload = function() {
      document.addEventListener("touchstart", function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function(event) {
        event.preventDefault();
      });
    };
  },

  beforeCreate() {
    this.getUserInfo(); //获取用户信息
    this.axios({
      url: this.api.index.shareconfig
    }).then(res => {
      if (res.error === 0) {
        this.wx.wxShare({
          title: res.shareconfig.title,
          desc: res.shareconfig.desc,
          imgUrl: res.shareconfig.icon,
          link: window.location.href,
          toast: "hide"
        });
      }
    });
  },

  created() {
    // 解决分享总是跳首页的问题
    window.location.href =
      window.location.href.split("#")[0] + "#" + this.$route.fullPath;
  },

  methods: {}
};
</script>




<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  font-size: 0.7rem;
}
html {
  font-size: 20px;
}
html,
body {
  width: 100%;
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
}
a {
  display: inline-block;
  text-decoration: none;
  color: inherit;
}
p {
  margin: 0;
}
ul li {
  list-style: none;
}
img,
video {
  width: 100%;
  display: block;
}
input {
  -webkit-appearance: none !important;
}
textarea,
input {
  border: none;
  box-sizing: border-box;
  background: 0 0;
  border-radius: 0;
  box-shadow: none;
  outline: 0;
}
textarea::placeholder,
input::placeholder {
  color: #999;
}
textarea {
  resize: none;
}

button {
  border: 0;
  background: none;
}

.van-tabs--line .van-tabs__wrap {
  height: 2.2rem;
}
.van-tab {
  font-size: 0.75rem;
  line-height: 2.2rem;
}
/*门店-业绩查看tab*/
.performanceCheck .van-tabs__wrap {
  height: 2.7rem;
  padding: 0.35rem 0 !important;
  background: #f4f5f6;
}
.performanceCheck .van-tabs__nav--card {
  border: 0 !important;
  height: 2rem !important;
  border-radius: 0.25rem;
  overflow: hidden;
  margin: 0 0.5rem;
}
.performanceCheck .van-tabs__nav--card .van-tab {
  line-height: 1.3rem;
  border: 0;
  padding: 0.35rem 0;
  font-size: 0.75rem;
  background: #fff;
}
.performanceCheck .van-tabs__nav--card .van-tab:nth-child(2) span {
  border-left: 1px solid rgba(231, 231, 231, 0.5);
  border-right: 1px solid rgba(231, 231, 231, 0.5);
}
.performanceCheck
  .van-tabs__nav--card
  .van-tab.van-tab--active:nth-child(2)
  span {
  border: 0;
}

.storeInfo__logo .van-uploader__upload {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue